export default "__VITE_ASSET__8e2150ea__"